import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=023fb9b4&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=ts&"
export * from "./Logo.vue?vue&type=script&lang=ts&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=023fb9b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023fb9b4",
  null
  
)

export default component.exports